/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ErrorHandler from '../Error/ErrorHandler';

const {ccclass, property} = cc._decorator;

export enum LogTypes
// tslint:disable:no-bitwise
{
    None =                  1 << 0,
    All =                   1 << 1,
    Game =                  1 << 2,
    Reel =                  1 << 3,
    StateManager =          1 << 4,
    UserMessageManager =    1 << 5,
    Utility =               1 << 6,
    Initialization =        1 << 7,
    Communicator =          1 << 8,
    Localization =          1 << 9,
    Audio =                 1 << 10,
    Effect =                1 << 11,
    Bonus =                 1 << 12,
    Configuration =         1 << 13,
    PopupManager =          1 << 14,
    Editor =                1 << 15,
}

@ccclass
export default class CLog {
    private static _currentLogTypes: LogTypes = LogTypes.All;
    private static readonly _leftIndent: string = `\t\t`;

    public static Debug: boolean = false;

    public static setLogTypes(type: LogTypes): void
    {
        this._currentLogTypes = type;
    }

    public static log(message: string, type: LogTypes, component?: cc.Component): void
    {
        if (!this.Debug) { return; }

        // Is type in current log types.
        if (this.IsType(type))
        {
            cc.log(this.getLogMessage(message));
            if (component) { cc.log(this.getComponentLogMessage(component, type)); }
        }
    }

    public static warn(message: string, type: LogTypes, component?: cc.Component): void
    {
        if (!this.Debug) { return; }

        // Is type in current log types.
        if (this.IsType(type))
        {
            cc.warn(this.getLogMessage(message));
            if (component) { cc.warn(this.getComponentLogMessage(component, type)); }
        }
    }

    public static error(message: string, component?: cc.Component, type: LogTypes = LogTypes.All, ignoreLogging: boolean = false): void
    {
        cc.error(this.getLogMessage(message));
        if (component) { cc.error(this.getComponentLogMessage(component, type)); }
        if (!ignoreLogging) { ErrorHandler.Instance.LogError(message); }
    }

    private static getLogMessage(message: string): string
    {
        return `${Date.now()} - ${message}`;
    }

    private static getComponentLogMessage(component: cc.Component, type: LogTypes): string
    {
        return  `${this._leftIndent}Node:         ${component.node.name}`
            + `\n${this._leftIndent}Component:    ${component.name}`
            + `\n${this._leftIndent}Log Type:     ${LogTypes[type]}`;
    }

    private static IsType(type: LogTypes): boolean
    {
        if (type === LogTypes.All || (this._currentLogTypes & LogTypes.All) !== 0) { return true; }

        return (this._currentLogTypes & type) !== 0;
    }
}
